import * as pointOnFeature from '@turf/point-on-feature';
import { Polygon } from 'geojson';
import { IPosition } from '../model';

const validatePosition = (value: IPosition) =>
  (value?.longitude === undefined && value?.latitude === undefined) ||
  (validateLongitude(value.longitude) && validateLatitude(value.latitude));

const validateLongitude = (value: number) => value >= -180 && value <= 180;

const validateLatitude = (value: number) => value >= -90 && value <= 90;

const round = (value: number) => Math.round(value * 1000000) / 1000000;

const findCenter = (polygon: Polygon) => pointOnFeature.default(polygon).geometry;

export const geoUtils = {
  validatePosition,
  validateLongitude,
  validateLatitude,
  round,
  findCenter,
};
